import iziToast from 'izitoast/dist/js/iziToast.min.js';
import 'jquery-validation/dist/jquery.validate';
import Message from '../components/Message';

export default (function (w, d) {
    'use strict';

    function ContactForm() {
        this.init();
    }

    ContactForm.prototype.init = function () {
        $('#contact-form').submit(function (event) {
            event.preventDefault();
            let form = $(this);
            let data = $(form).serialize();
            form.find('.c-form-input__error').removeClass('c-form-input__error');

            $.ajax({
                url: $(form).attr('action'),
                method: 'post',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: data,
                success: function (response) {
                    if (response.status === 'success') {
                        new Message(response.message, 'success');
                    }
                    $('#contact-form input').val('');
                    $('#contact-form textarea').val('');
                    grecaptcha.reset();
                },
                error: function (error) {
                    console.log(error);
                    switch (error.status) {
                        case 500: {
                            new Message(error.statusText, 'error');
                        }
                            break;
                        case 422: {
                            let errorMessages = error.responseJSON.errors;
                            console.log('errorMessages', errorMessages);
                            for (const prop in errorMessages) {
                                new Message(errorMessages[prop][0], 'error');
                                form.find('#' + prop).addClass('c-form-input__error')
                            }
                        }
                            break;
                    }
                    grecaptcha.reset();
                }
            });
            return false; // required to block normal submit since you used ajax
        })
    }

    return ContactForm;
}(window, document));

